"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

(function ($) {
  var winW = window.innerWidth;
  var winH = $(window).height();
  var is_fullmode = false;
  var topPos = 0;
  var beforTopPos = 0;
  var breakpoint = 768;
  var breakpointTab = 1079;
  if (winW > breakpoint) is_fullmode = true;
  var isSP = false;
  if (ua.isiPhone || ua.isiPad || ua.isiPod || ua.isAndroid) isSP = true;
  var isScrolling = false;
  var isParticle = false; //パーティクル起動

  var isOpening = false; //オープニングアニメーションが終了したか

  var isAvailMenuBtn = true; //メニュー開閉中のフラグ

  var scrollFixed;
  var hitEvent;
  var gmenuData = new Array();
  var el_html = $('html');
  var el_body = $('body');
  var el_header = $('.site-header');
  var isHome = el_body.hasClass('home');
  var transitionEnd = 'oTransitionEnd mozTransitionEnd webkitTransitionEnd transitionend';
  var animationEnd = 'webkitAnimationEnd oanimationend msAnimationEnd animationend';
  var drawer = new Drawer();
  var ut = new Utility(); //

  function setPcPosition() {
    $('.handwrite-box img').removeAttr('style');

    if (winW < breakpointTab) {//$('.nav-wrapper').height(winH-40);
    } else {
      $('.nav-wrapper').removeAttr('style');
    }
  }

  function setSpPosition() {
    var img_scale = winW / breakpoint * 1.3;
    $('.handwrite-box img').css('transform', "scale(".concat(img_scale, ")"));
  }

  if (isSP) {
    el_html.addClass('SP');
    el_body.addClass('transition-none');
    hitEvent = 'touchstart';
    var adjustHeader = 0;
    if (winW < breakpoint + 1) adjustHeader = 70;
  } else {
    el_html.addClass('PC');
    hitEvent = 'click';
  }

  if (is_fullmode) {
    setPcPosition();
  } else {
    setSpPosition();
  } //iOSでスクロール無効対策


  var movefun = function movefun(event) {
    event.preventDefault();
  }; //スクロール


  var ptBTN = $('.pagetop');
  var appearPoint;
  appearPointF();
  var adjust, absoluteBottom, fixedBottom, fixedPoint, beforePos;
  beforePos = 0;
  absoluteBottom = 100;
  $(window).on('scroll', function () {
    scrollAction();
    isScrolling = true;
    ut.timer(200).then(function () {
      isScrolling = false;
    });
    currentCheck();
  });

  function scrollAction(first) {
    beforePos = topPos;
    topPos = $(window).scrollTop(); //ヘッダーfixed

    if (topPos < appearPoint) {
      el_header.removeClass('fixed');
      $('.btn-scroll').removeClass('hidden');
    }

    if (topPos > appearPoint) {
      if (first == 'first') {
        el_body.addClass('transition-none');
      }

      el_header.addClass('fixed');
      $('.btn-scroll').addClass('hidden');
    } //右ナビゲーション出し入れ


    if (topPos < 550 && !ptBTN.hasClass('fadeOut')) {
      ptBTN.addClass('fadeOut');
      $('.sidebar-right').addClass('fadeOut');
    }

    if (topPos > 550) {
      ptBTN.removeClass('fadeOut');
      $('.sidebar-right').removeClass('fadeOut');
    }
  }

  scrollAction('first');

  function appearPointF() {
    if (is_fullmode) {
      //appearPoint =  $('.site-header .outer-box').height();
      appearPoint = 155;
    } else {
      appearPoint = winH;
    }
  }
  /*smoothScroll*/


  var v_b = 0;
  var anchorName = '';
  var scroll = new SmoothScroll('a[href*="#"]', {
    speed: 1000,
    speedAsDuration: true,
    customEasing: function customEasing(time) {
      //easeOutExpo
      var t = time; // : 時間(進行度)

      var b = 0; //: 開始の値(開始時の座標やスケールなど)

      var c = 1; //: 開始と終了の値の差分

      var d = 1; //: Tween(トゥイーン)の合計時間

      var v = c * (-Math.pow(2, -10 * t / d) + 1) + b;

      if (v_b == v) {
        v = 0;
      }

      v_b = v;
      return v;
    },
    updateURL: false,
    offset: function offset(anchor, toggle) {
      var offset = 90;
      anchorName = toggle.getAttribute('href');

      if (is_fullmode) {
        if (isHome) {
          offset = 0;
        } else {
          offset = 120;
        }
      } else {
        if (anchorName == '#page') {
          offset = 0;
        } else {
          offset = 100;
        }
      }

      return offset;
    }
  });
  Delighters.config({
    start: 0.85,
    end: 1
  }); // ナビゲーションのリンクを指定

  var navLink = $('.nav-top ul li a'); // 各コンテンツのページ上部からの開始位置と終了位置を配列に格納しておく

  var contentsArr = new Array();

  function contentsPosition() {
    for (var i = 0; i < navLink.length; i++) {
      // コンテンツのIDを取得
      var targetContents = navLink.eq(i).attr('href'); // ページ内リンクでないナビゲーションが含まれている場合は除外する

      if (targetContents.charAt(0) == '#') {
        // ページ上部からコンテンツの開始位置までの距離を取得
        var targetContentsTop = $(targetContents).offset().top - 5; // ページ上部からコンテンツの終了位置までの距離を取得

        var targetContentsBottom = targetContentsTop + $(targetContents).outerHeight(true) - 1; // ページ上部からコンテンツの開始位置までの距離を取得

        var targetContentsTop_down = $(targetContents).offset().top - $(targetContents).outerHeight(true) / 2; // ページ上部からコンテンツの終了位置までの距離を取得

        var targetContentsBottom_down = targetContentsTop + $(targetContents).outerHeight(true) / 2 - 1; // 配列に格納

        contentsArr[i] = [targetContentsTop, targetContentsBottom, targetContentsTop_down, targetContentsBottom_down];
      }
    }

    ;
  }

  contentsPosition(); // 現在地をチェックする

  function currentCheck() {
    var adjast = 90; //headerの高さ
    //方向

    var direction = topPos > beforePos ? 'up' : 'down';

    for (var i = 0; i < contentsArr.length; i++) {
      // 現在のスクロール位置が、配列に格納した開始位置と終了位置の間にあるものを調べる
      if (direction == 'up') {
        if (contentsArr[i][0] <= topPos + adjast && contentsArr[i][1] >= topPos + adjast) {
          // 開始位置と終了位置の間にある場合、ナビゲーションにclass="current"をつける
          navLink.removeClass('current');
          navLink.eq(i).addClass('current');
          i = contentsArr.length;
        }
      } else {
        //down
        if (contentsArr[i][2] <= topPos + adjast && contentsArr[i][3] >= topPos + adjast) {
          navLink.removeClass('current');
          navLink.eq(i).addClass('current');
          i = contentsArr.length;
        }
      }
    }
  } //サイドバー


  $('.sidebar-right').hover(function () {
    //on
    if (isHome) {
      $(this).addClass('hover');
    } else if (!$('.nav-footer').hasClass('fadeOut')) {
      $(this).addClass('hover');
    }
  }, function () {
    //off
    $(this).removeClass('hover');
  }); //同意するにチェックでsubmitできるようにする

  if ($('#agree-1').prop('checked') == false) {
    $('.to-confirm').attr('disabled', 'disabled');
  }

  $('#agree-1').click(function () {
    if ($(this).prop('checked') == false) {
      $('.to-confirm').attr('disabled', 'disabled');
    } else {
      $('.to-confirm').removeAttr('disabled');
    }
  }); //ブラウザのバリデーションチェックを無効

  $('.mw_wp_form form').attr('novalidate', 'novalidate'); //問い合わせフォーム、確認とサンクスとエラーページでスクロール

  function toPrimaryScroll() {
    var targetOffset; //header+余白分の高さを引く

    if (is_fullmode) {
      targetOffset = $('#primary').offset().top - 150;
    } else {
      targetOffset = $('.content-header').height();
    }

    $('html,body').animate({
      scrollTop: targetOffset
    }, "fast");
  }

  function toHeaderFormScroll() {
    var targetOffset;

    if (is_fullmode) {
      targetOffset = $('.indigator-box').offset().top - 130;
    } else {
      targetOffset = $('.indigator-box').offset().top - 80;
    }

    $('html,body').animate({
      scrollTop: targetOffset
    }, "fast");
  }

  if (el_body.hasClass('page-confirm') || el_body.hasClass('page-thanks')) {
    toPrimaryScroll();
  }

  if (el_body.hasClass('page-error')) {
    toHeaderFormScroll();
  } //フォームでエラーのclass付与


  $("dd:has('span.error'):not(.input-2col)").addClass("error-box");
  $("dd.input-2col span.error").each(function () {
    $(this).prev().addClass('error-input');
  }); //投稿本文見出し

  $('.single-post .site-main .article-body').find('h1,h2,h3,h4,h5,h6').addClass('heading02');

  if (isHome) {
    document.getElementById('pickup').addEventListener('click', function () {
      var href = this.querySelector('a').getAttribute('href');
      location.href = href;
    });
  } //slick.js：トップページ


  var is_topSlider = false;
  var $slider = $('.main-slider');

  if (isHome) {
    if ($slider.children('div').size() > 1) {
      is_topSlider = true;
      $slider.slick({
        dots: true,
        infinite: true,
        arrows: false,
        speed: 100,
        fade: true,
        autoplay: false,
        autoplaySpeed: 5000,
        pauseOnFocus: false,
        pauseOnHover: true,
        pauseOnDotsHover: true,
        draggable: false,
        swipe: false,
        touchMove: false,
        cssEase: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
        initialSlide: 0,
        responsive: [{
          breakpoint: breakpoint
        }, {
          breakpoint: breakpointTab
        }]
      });
      $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var current = $slider.slick('slickCurrentSlide') + 1;
        if (current == $('.slick-track').children('div').length) current = 0;
        $('.slick-slide').css('z-index', '999');
        $('.slick-slide').eq(currentSlide).css('z-index', '1000');
        $('.slick-slide').eq(nextSlide).css('z-index', '1001');
        $('.slick-slide').eq(nextSlide).addClass('zoom');
        setTimeout(function () {
          $('.slick-slide:not(.slick-current)').removeClass('zoom');
        }, 1000);
      });
      $slider.on('reInit', function (slick, currentSlide) {
        $slider.slick('slickPlay');
        $('.slick-slide').eq(0).css('z-index', '1001');
      });
    }
  } //slick.js：商品詳細のみ


  if (el_body.hasClass('single-products')) {
    var productsSlider = ".slick-main"; // スライダー

    var thumbnailItem = ".slick-thumbnail div.thumbnail"; // サムネイル画像アイテム

    var productImg = document.querySelector(productsSlider);
    var productImgLength = productImg.childElementCount; //console.log('productImgLength:',productImgLength)

    if (productImgLength > 1) {
      // サムネイル画像アイテムに data-index でindex番号を付与
      $(thumbnailItem).each(function () {
        var index = $(thumbnailItem).index(this);
        $(this).attr("data-index", index);
      }); // スライダー初期化後、カレントのサムネイル画像にクラス「thumbnail-current」を付ける
      // 「slickスライダー作成」の前にこの記述は書いてください。

      $(productsSlider).on('init', function (productsSlider) {
        var index = $(".slide-item.slick-slide.slick-current").attr("data-slick-index");
        $(thumbnailItem + '[data-index="' + index + '"]').addClass("thumbnail-current");
      }); //slickスライダー初期化

      $(productsSlider).slick({
        speed: 1000,
        autoplaySpeed: 5000,
        autoplay: true,
        arrows: false,
        fade: true,
        infinite: false,
        kind: 'products'
      }); //サムネイル画像アイテムをクリックしたときにスライダー切り替え

      $(thumbnailItem).on('click', function () {
        var index = $(this).attr("data-index");
        $(productsSlider).slick("slickGoTo", index, false);
      }); //サムネイル画像のカレントを切り替え

      $(productsSlider).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        $(thumbnailItem).each(function () {
          $(this).removeClass("thumbnail-current");
        });
        $(thumbnailItem + '[data-index="' + nextSlide + '"]').addClass("thumbnail-current");
      });
    } else {
      //画像が１つだけ。スライダー無し
      document.querySelector('.slick-thumbnail').setAttribute('style', 'display:none');
    }
  } //if
  //lightbox


  var luminousTrigger = document.querySelectorAll('.luminous');

  if (luminousTrigger !== null) {
    new LuminousGallery(luminousTrigger);
  } //矢印付与


  $('.arrow-down.auto').each(function () {
    $(this).append('<i class="icon-down"></i>');
  }); //外部リンクにアイコン

  $('.article-body p a[target=_blank]').after('<i class="icon-external-link-alt"></i>');
  $('.article-body blockquote a[target=_blank]').after('<i class="icon-external-link-alt"></i>'); //ボタンにhover用のspanを追加

  $('.btn').wrapInner('<span class="text">'); //$('.btn').append('<span class="bg"></span>');
  //幅で文字数を変更

  function omitTitle() {
    _toConsumableArray(document.querySelectorAll('.post-title')).forEach(function (el, index) {
      var originalTitle = ut.getAttr(el, 'data-title');
      var width = el.getBoundingClientRect().width;
      var style = window.getComputedStyle(el, null).getPropertyValue('font-size');
      var fontSize = parseFloat(style);
      var oneLineCharacters = Math.floor(width / fontSize); //判定に必要な親node取得

      var parent = el.parentNode.parentNode.parentNode.parentNode.parentNode.className;
      var lines = 3;
      if (is_fullmode && parent == 'box-body') lines = 2;
      var numberOfCharacters = oneLineCharacters * lines - 2;
      var omitTitle = originalTitle.substring(0, numberOfCharacters);
      if (originalTitle.length > numberOfCharacters) omitTitle += '…';
      el.innerText = omitTitle;
    });
  } //現在のページ


  function currentPage() {
    var className = document.querySelector('body').getAttribute('class');
    var index; //console.log(className);

    if (className.indexOf('home') > -1) {
      index = 0;
    } else if (className.indexOf('about') > -1) {
      index = 1;
    } else if (className.indexOf('products') > -1) {
      index = 2;
    } else if (className.indexOf('howto') > -1) {
      index = 3;
    } else if (className.indexOf('post') > -1) {
      index = 4;
    } else if (className.indexOf('gallery') > -1) {
      index = 5;
    } else if (className.indexOf('contact') > -1) {
      index = 6;
    } else {
      index = 0;
    }

    return index;
  }

  var current = currentPage();

  function gMenuHover() {
    var gMenuUl = document.getElementById('primary-menu');
    var bar = document.createElement('div');
    var lastIndex = gmenuData.length - 1;
    document.querySelector('.menu-global-nav-container').appendChild(bar);
    var barEl = document.querySelector('.menu-global-nav-container div');
    barEl.classList.add('bar'); //.setAttribute('style','opacity:0');

    _toConsumableArray(document.querySelectorAll('#primary-menu li a')).forEach(function (el, index) {
      el.addEventListener('mouseenter', function () {
        barEl.style.opacity = 1;
        barEl.style.width = gmenuData[index][0] + 'px';
        barEl.style.left = gmenuData[index][1] + 'px';

        if (current == 0) {
          //gmenu以外
          gmenuData[lastIndex][1] = gmenuData[index][1] - 50;
        }
      }, false);
      gMenuUl.addEventListener('mouseleave', function () {
        if (current == 0) {
          //gmenu以外
          barEl.style.opacity = 0;
          barEl.style.left = gmenuData[lastIndex][1] + 'px';
        } else {
          barEl.style.width = gmenuData[lastIndex][0] + 'px';
          barEl.style.left = gmenuData[lastIndex][1] + 'px';
        }
      }, false);
    });

    if (current == 0) {
      //gmenu以外
      barEl.style.opacity = 0;
    } else {
      barEl.style.opacity = 1;
    }

    barEl.style.width = gmenuData[lastIndex][0] + 'px';
    barEl.style.left = gmenuData[lastIndex][1] + 'px';
  }

  function setGmenuData() {
    gmenuData.length = 0;
    var wLi, rLi; //位置と幅を取得

    _toConsumableArray(document.querySelectorAll('#primary-menu li a')).forEach(function (el, i) {
      wLi = Math.ceil(el.getBoundingClientRect().width);
      rLi = Math.ceil(el.offsetLeft);
      gmenuData.push([wLi, rLi]);
    });

    if (current == 0) {
      wLi = 60;
      rLi = gmenuData[0][1] - 50;
      gmenuData.push([wLi, rLi]);
    } else {
      gmenuData.push(gmenuData[current]);
    }
  }

  function heroAreaHeight() {
    if (isHome) {
      winH = $(window).height();
      $('#hero').height(winH);
      $('#pickup').css({
        top: winH - 200
      });
      $('.btn-scroll').css({
        top: winH
      });
    }
  } //読み込み完了後


  $(window).on('load', function () {
    contentsPosition();
    currentCheck();
    omitTitle();
    el_body.removeClass('transition-none');
    el_body.removeClass('loading'); //slider起動

    if (is_topSlider) {
      $slider.slick('slickPlay');
      $('.slick-slide').eq(0).css('z-index', '1001');
    }

    setGmenuData();
    gMenuHover();
    heroAreaHeight(); //オープニングアニメーション再生

    setTimeout(function () {
      isOpening = true;
      el_body.addClass('loaded');
    }, 1000);
    setTimeout(function () {
      isOpening = true;
      el_body.addClass('loaded-end');
      $slider.slick('slickPlay');
      $('.slick-slide').eq(0).css('z-index', '1001');
    }, 1500);
  }); //リサイズ

  window.addEventListener('resize', resizeHandler);

  if (isSP) {
    window.addEventListener('orientationchange', function () {
      setTimeout(function () {
        heroAreaHeight();
      }, 100);
    });
  }

  function resizeHandler() {
    function delayed() {
      resize();
      resizeTimeout = null;
    }

    if (typeof resizeTimeout != 'undefined') {
      clearTimeout(resizeTimeout);
    }

    var resizeTimeout = setTimeout(delayed, 300);
    el_body.addClass('transition-none');
  }

  function resize() {
    var beforeWin = winW;
    winW = window.innerWidth;
    winH = $(window).height();

    if (!isSP) {
      heroAreaHeight();
    }

    el_body.removeClass('transition-none'); //横幅が変わった時だけ処理をする

    if (beforeWin != winW) {
      appearPointF();

      if (is_topSlider) {
        $slider.slick('slickSetOption', {}, true);
      }

      if (winW > breakpoint) {
        //PC
        is_fullmode = true;
        contentsPosition();
        setPcPosition();
        setGmenuData();
        var barEl = document.querySelector('.menu-global-nav-container div');
        barEl.style.width = gmenuData[gmenuData.length - 1][0] + 'px';
        barEl.style.left = gmenuData[gmenuData.length - 1][1] + 'px';
      } else {
        //SP
        is_fullmode = false;
        setSpPosition();

        if (isHome) {}
      }

      if (drawer.isStatus === 'open') {
        //SPメニュー閉じる
        drawer.toggleMenu();
      }

      omitTitle();
    }
  } // END resizeHandler

})(jQuery); // Fully reference jQuery after this point.